import { useTheme } from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { MobileRecordingIcon } from '../icons/MobileRecordingIcon';
import { translationKeys } from '../translations';

import { AiAssistantMainMenuTileItemContainer } from './AiAssistantMainMenuTileItemContainer';
import { StyledStrongText } from './AiAssistantMainMenuTileItemMobileRecording.styled';

const t = translationKeys.mainMenuTileItem;

export const AiAssistantMainMenuTileItemMobileRecording = (): JSX.Element => {
   const theme = useTheme();

   return (
      <AiAssistantMainMenuTileItemContainer icon={<MobileRecordingIcon />} backgroundColor={theme.backgroundBody}>
         <StyledFlex direction={'column'} gap={8} alignItems={'center'} justifyContent={'center'}>
            <MobileRecordingIcon />
            <StyledStrongText testId={'mobileRecordingInProgress'}>
               <Translate>{t.mobileRecordingInProgress}</Translate>
            </StyledStrongText>
         </StyledFlex>
      </AiAssistantMainMenuTileItemContainer>
   );
};
